import { render, staticRenderFns } from "./MessagesForm.vue?vue&type=template&id=6dd472c2&scoped=true&lang=html&"
import script from "./MessagesForm.vue?vue&type=script&lang=js&"
export * from "./MessagesForm.vue?vue&type=script&lang=js&"
import style0 from "./MessagesForm.vue?vue&type=style&index=0&id=6dd472c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd472c2",
  null
  
)

export default component.exports